module.exports = __webpack_public_path__ + "img/kucun.0d7e04fa.svg";